import { create } from 'zustand';

// Session-scoped gate for the root route. NOT persisted — it tracks whether the
// current session's boot-sync (fetch /me + hydrate stores) has settled.
//
//   'idle'    — no decision made yet (initial render)
//   'syncing' — a session exists and /me is being fetched/hydrated
//   'settled' — either there's no session (nothing to wait for) or the fetch has
//               resolved/rejected; the root switch may now route safely
//
// Without this, RootRedirect reads localStorage synchronously and bounces a
// just-verified user (fresh browser, empty localStorage) to /intro before
// boot-sync can hydrate their DB-persisted config. See use-boot-sync.ts + app.tsx.
export type BootSyncStatus = 'idle' | 'syncing' | 'settled';

interface BootSyncState {
  status: BootSyncStatus;
  setStatus: (status: BootSyncStatus) => void;
}

export const useBootSyncStore = create<BootSyncState>((set) => ({
  status: 'idle',
  setStatus: (status) => set({ status }),
}));
